import t from "./index892.js";
import e from "./index896.js";
import o from "./index897.js";
var i = "[object Null]", f = "[object Undefined]", r = t ? t.toStringTag : void 0;
function m(n) {
  return n == null ? n === void 0 ? f : i : r && r in Object(n) ? e(n) : o(n);
}
export {
  m as default
};
